import * as React from "react";
const SvgPause = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "#FFF", strokeLinejoin: "bevel", d: "M6.5 2.14342857L6.5 18.0005714M13.5 2.14342857L13.5 18.0005714" }));
export default SvgPause;
